import { render, staticRenderFns } from "./collect-exhibitor.vue?vue&type=template&id=57ad5eaa&scoped=true&"
import script from "./collect-exhibitor.vue?vue&type=script&lang=js&"
export * from "./collect-exhibitor.vue?vue&type=script&lang=js&"
import style0 from "./collect-exhibitor.vue?vue&type=style&index=0&id=57ad5eaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad5eaa",
  null
  
)

export default component.exports